import * as React from "react"
// @ts-ignore
import {Quotes} from "@phosphor-icons/react"

const Testimonial = () => {
    return (
        <section className="w-full bg-slate-50 py-24">
            <div className="max-w-3xl mx-auto px-6 text-center">
                <Quotes size={36} weight="fill" color="#10B981" className="mx-auto mb-6"/>
                <p className="text-2xl md:text-3xl font-medium text-slate-900 leading-relaxed tracking-tight">
                    &ldquo;We replaced three tools with Neugence and our open rates climbed 38%
                    in the first quarter. The team finally enjoys shipping campaigns.&rdquo;
                </p>
                <div className="mt-10 flex items-center justify-center gap-4">
                    <div className="w-12 h-12 rounded-full bg-emerald-50 border border-emerald-200 flex items-center justify-center text-emerald-700 font-semibold">
                        AR
                    </div>
                    <div className="text-left">
                        <div className="text-base font-semibold text-slate-900">Ananya Rao</div>
                        <div className="text-sm text-slate-600">Head of Growth, Lumen Goods</div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonial
